module.exports = __webpack_public_path__ + "img/downtown-roanoke.92fcdfe8.jpeg";